import { bindable } from "aurelia-framework";

export class LinkList {
    @bindable inputList;
}